import { Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./AcknowledgeUserDelete.module.scss";
import { archiveUserService } from "../../../services/DashboardServices";

const AcknowledgeUserDelete = ({
  openAcknowledgeUserDelete,
  closeAcknowledgeUserDelete,
  refresh,
}) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    closeAcknowledgeUserDelete();
  };

  useEffect(() => {
    if (
      openAcknowledgeUserDelete &&
      openAcknowledgeUserDelete.open
      // openAcknowledgeUserDelete.sessionId
    ) {
      handleOpen();
    }
  }, [openAcknowledgeUserDelete]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className={styles.AcknowledgeDeleteUserContainer}
    >
      <div className="bg-white w-[80vw] h-auto max-w-[500px] my-[100px] rounded-[10px] outline-none p-6">
        <div className="text-[#101828]  font-semibold text-xl leading-9 mb-5 text-center">
          Are you sure you want to Archive this user?
        </div>
        <div className="flex justify-center gap-4">
          <button
            className="
              text-[#fff]
              font-normal
              text-sm
              leading-5
              h-[30px]
              w-[80px]
              border-[1px]
              border-[#788CFC]
              rounded-[5px]
              bg-[#788CFC]
              transition
              duration-300
              ease-in-out
              flex
              justify-center
              items-center
            "
            onClick={() => {
              archiveUserService(
                openAcknowledgeUserDelete.data.end_user_id,
                true
              ).then((res) => {
                console.log("res", res);
                refresh();
                handleClose();
              });
            }}
          >
            Archive
          </button>
          <button
            className="
              text-[#788CFC]
              font-normal
              text-sm
              leading-5
              h-[30px]
              w-[80px]
              border-[1px]
              border-[#788CFC]
              rounded-[5px]
              transition
              duration-300
              ease-in-out
              flex
              justify-center
              items-center
              "
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AcknowledgeUserDelete;
